'use client';

import LoginFormFooter from '@/components/login/LoginFormFooter';
import LoginFormHeader from '@/components/login/LoginFormHeader';
import MicrosoftProvider from '@/components/login/MicrosoftProvider';
import OTPFlow from '@/components/login/OTPAuthFlow';
import OTPProvider from '@/components/login/OTPProvider';
import { useSearchParams } from 'next/navigation';

const LoginForm = () => {
  const searchParams = useSearchParams();
  const provider = searchParams.get('provider');

  return (
    <section className="flex w-96 flex-col gap-y-4 rounded-md border border-border bg-white p-6">
      <LoginFormHeader />
      {provider === 'otp' ? (
        <OTPFlow />
      ) : (
        <>
          <OTPProvider />
          <MicrosoftProvider />
        </>
      )}
      <LoginFormFooter />
    </section>
  );
};

export default LoginForm;
